import { services } from '@/mocks/home';
import SectionHeading from './SectionHeading';

export default function Services() {
  return (
    <section id="services" className="w-full bg-background-50 py-16 md:py-24">
      <div className="px-4 md:px-10">
        <div className="reveal">
          <SectionHeading
            eyebrow="Our Products"
            title="主营产品与经营范围"
            subtitle="覆盖建筑建材、机械电气、金属材料、电子配件、五金耗材等多个大类，支持一站式采购与配套供应。"
          />
        </div>

        <div className="mt-10 md:mt-14 grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
          {services.map((item, index) => (
            <article
              key={item.title}
              className="reveal flex flex-col p-6 md:p-8 rounded-lg bg-background-100 border border-background-200 hover:border-primary-300 transition-colors"
              style={{ transitionDelay: `${index * 60}ms` }}
            >
              <div className="flex items-start justify-between gap-4">
                <div className="w-12 h-12 flex items-center justify-center rounded-md bg-primary-500 text-background-50">
                  <i className={`${item.icon} text-2xl`}></i>
                </div>
                <span className="font-heading font-bold text-3xl md:text-4xl text-background-300">
                  0{index + 1}
                </span>
              </div>

              <h3 className="mt-5 font-heading font-semibold text-foreground-950 text-lg md:text-xl">
                {item.title}
              </h3>
              <p className="mt-3 text-sm text-foreground-600 leading-relaxed flex-1">{item.desc}</p>

              <ul className="mt-5 flex flex-wrap gap-2">
                {item.points.map((point) => (
                  <li
                    key={point}
                    className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-accent-100 text-accent-900 text-xs"
                  >
                    <i className="ri-check-line text-accent-700"></i>
                    {point}
                  </li>
                ))}
              </ul>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}